import {AuthLayout} from "../layouts/AuthLayout.tsx";
import {SignInView} from "../views/SignInView.tsx";

export const SignInPage = () => {
    return (
        <AuthLayout showWelcomePanel>
            <SignInView />
        </AuthLayout>
    )
}
